import gql from 'graphql-tag';

const query = gql`
  query SalePaymentGetByToken($token: String!) {
    sale {
      payment {
        getByToken(token: $token) {
          id
          user {
            id
            email
          }
        }
      }
    }
  }
`;

export default query;
